module.exports = __webpack_public_path__ + "media/online_university/less-debt@2x-3f523bef.png";